export const API_KEY = "AIzaSyAxk_bh1By57StpQQVTyT2NgeINhUrqZqo";
export const CONTEXT_KEY = "b5ab5289a4204a0e0";
